
import { defineComponent, PropType } from 'vue';
import Message from '@/models/MessageModel';
import AnswerButton from '@/components/App/AnswerButton/index.vue';
import CalculaterButtonWidth from '@/helpers/CalculaterButtonWidth';

import SlideItem from './SlideItem.vue';

interface Ctx {
	direction: string;
}

export default defineComponent({
	name: 'carousel',

	components: {
		SlideItem,
		AnswerButton
	},

	props: {
		message: {
			type: Object as PropType<Message>
		},

		isLastMessage: {
			type: Boolean
		},

		isWidget: {
			type: Boolean,
			required: true
		}
	},

	emits: ['init'],

	setup() {
		return {
			CalculaterButtonWidth
		};
	},

	data() {
		return {
			directionMoved: 0,
			positionStyleObject: {}
		};
	},

	computed: {
		// Говорит, когда мы уткнулись в предел по двиганию карусели
		isOvermoved(): boolean {
			const length = this.message?.slides?.length ?? 0;
			return Math.abs(this.directionMoved) >= length || this.directionMoved > 0;
		},

		isPhoneSize(): boolean {
			return this.$q.screen.width < 450;
		}
	},

	mounted() {
		this.$emit('init');
	},

	methods: {
		handleSwipe({ direction }: Ctx) {
			if (direction === 'right') {
				this.moveRight();
			}

			if (direction === 'left') {
				this.moveLeft();
			}
		},

		moveRight() {
			this.directionMoved += 1;
			if (this.isOvermoved) {
				this.togglePosition();
			} else {
				this.acceptPosition();
			}
		},

		moveLeft() {
			this.directionMoved -= 1;
			if (this.isOvermoved) {
				this.togglePosition();
			} else {
				this.acceptPosition();
			}
		},

		togglePosition() {
			// Здесь либо прокручиваем карусель в конец, либо в начало
			if (this.directionMoved > 0) {
				this.directionMoved = -(this.message?.slides?.length ?? 1) + 1;
			} else {
				this.directionMoved = 0;
			}

			this.acceptPosition();
		},

		acceptPosition() {
			// Узнаем какая ширина у одного элемента карусели
			const oneSlideElement = document.getElementById(`slide-0`);
			if (!oneSlideElement) return;

			// Не удалось найти способ получить отступ у элемента, поэтому он захардкоден тут
			const marginRight = 8;
			const sizeOfOneSlide = oneSlideElement.offsetWidth + marginRight;

			this.positionStyleObject = {
				transform: `translateX(${this.directionMoved * sizeOfOneSlide}px)`
			};
		},

		// Подсказывает скрывать ли нам итем карусели
		isHiddenSlide(orderOfSlide: number): boolean {
			const wrapperContainsSlides = this.isPhoneSize ? 1 : 3;
			const orderWithMoved = orderOfSlide + this.directionMoved;

			return orderWithMoved > wrapperContainsSlides || orderWithMoved <= 0;
		}
	}
});
